export class ConfigDB {
    static data = {
      settings: {
        layout_type: 'ltr',
        layout_class: 'compact-wrapper',
        sidebar: {
          iconType: 'stroke',
        },
        sidebar_setting: 'default-sidebar',
      },
      color: {
        primary_color:'#E82C86',
        secondary_color: '#5E296A',
        mix_background_layout: 'dark-sidebar',
      }
    };
  }
  export default ConfigDB;